/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { collectionChallengeItemSchema } from '../listCollectionChallenges';

const challengeItemWithVideoCountSchema = collectionChallengeItemSchema.extend({
  videoCount: z.number(),
});

export type IListPublicCollectionChallengesBySlugV2Item = z.infer<
  typeof challengeItemWithVideoCountSchema
>;

export const listPublicCollectionChallengesBySlugV2ResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(challengeItemWithVideoCountSchema),
  pagination: z.object({
    totalGroups: z.number(),
    nextCursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export type IListPublicCollectionChallengesBySlugV2Response = z.infer<
  typeof listPublicCollectionChallengesBySlugV2ResponseSchema
>;
